import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import { ReleaseState } from '../../../../types/recharge';
import { InvoiceStatus } from '../../../../utils/invoiceUtils';
import styles from './InvoiceAlert.module.css';
export const InvoiceAlert = ({ status, releaseState, isVisible = false, className = '', variant = 'info', 'data-testid': testId = 'InvoiceAlert', }) => {
    const { t } = useTranslation();
    const [isAlertVisible, setIsAlertVisible] = useState(isVisible);
    useEffect(() => {
        setIsAlertVisible(isVisible);
    }, [isVisible]);
    if (!isVisible || status === InvoiceStatus.AVAILABLE) {
        return null;
    }
    if (!isAlertVisible) {
        return null;
    }
    const alertClass = variant === 'error' ? styles.alertError : styles.alert;
    const iconName = variant === 'error' ? 'inputError' : 'informationFilled';
    const handleClose = () => {
        setIsAlertVisible(false);
    };
    const getMessage = () => {
        if (releaseState === ReleaseState.LIBERATED) {
            return t('benefits.invoice.alert.credit-released');
        }
        return t('benefits.invoice.alert.processing');
    };
    return (_jsxs("div", { className: `${alertClass} ${className}`, "data-testid": `view${testId}Alert`, children: [_jsx(Icon, { name: iconName, className: styles.alertIcon, "data-testid": `icon${testId}AlertIcon` }), _jsx("div", { className: styles.alertText, "data-testid": `textView${testId}Text`, children: getMessage() }), _jsx("button", { type: 'button', className: styles.alertClose, onClick: handleClose, "aria-label": t('alert.close'), "data-testid": `button${testId}Close`, children: _jsx(Icon, { name: 'actionClose', alt: t('alert.close'), className: styles.alertCloseIcon, "data-testid": `iconClose${testId}CloseIcon` }) })] }));
};
export default InvoiceAlert;
